<template>
	<InputAmount
		:header-title="t('newPayment.sum')"
		v-model="amount"
		:currency="currency.name"
		@update:focused="handleFocusInputAmount"
		@blur="handleBlurInputAmount"
	>
		<template #header-end>
			<InputAmountRange
				:ranges="minMaxRangesAmount"
				:currency="currency.name"
				:is-loading="isPaymentSystemsLoading"
				:is-error="textMaxMinRangeError"
			/>
		</template>
		<template #content>
			<Transition name="fade" mode="out-in">
				<InputAmountButton
					v-if="!isPaymentSystemsLoading"
					@click="clickMaxHandler"
					text="MAX"
				/>
			</Transition>
		</template>
	</InputAmount>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import InputAmountButton from "@components/ui/input-amount/InputAmountButton.vue";
import InputAmountRange from "@components/ui/input-amount/InputAmountRange.vue";
import InputAmount from "@components/ui/input-amount/InputAmount.vue";
import NewPaymentController from "@/targets/light/components/popups/create-payment/NewPaymentController";

const { t } = useI18n({useScope: 'global'});
const viewController = NewPaymentController.getInstance();

const inputAmountFocused = ref<boolean>(false);

const {
	amount,
	currency,
	isPaymentSystemsLoading,
	minMaxRangesAmount,
	textMaxMinRangeError
} = viewController;

const clickMaxHandler = () => {
	viewController.setMaxAmount();
}

const handleBlurInputAmount = () => {
	inputAmountFocused.value = false;
	if (amount.value === 0) {
		amount.value = viewController.calculateStartAmountValue();
	}
}

const handleFocusInputAmount = (value: boolean) => {
	textMaxMinRangeError.value = false;
	inputAmountFocused.value = value;
}
</script>
